import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb"

import { get } from "helpers/api_helper"
import PromoCodeForm from "components/PromoCodes/PromoCodeForm"
import SpinnerLoader from "components/Loader/SpinnerLoader"
const EditPromoCode = props => {
  const [PromoCode, setPromoCode] = useState({})
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    setLoading(true)
    get(`promoCodes/${props.match.params.id}`).then(res => {
      const { status, result } = res
      setPromoCode(result)
      setLoading(false)
    })
  }, [])

  return (
    <div className="page-content">
      <MetaTags>
        <title>Promo Codes | GoFetchIt</title>
      </MetaTags>
      <div className="container-fluid">
        <Breadcrumb
          breadcrumb1={{
            title: "Promo Codes",
            href: "/promo-codes",
          }}
          breadcrumbItem="Edit Promo Code"
        />
        {loading ? (
          <SpinnerLoader/>
        ) : (
          <PromoCodeForm
            p_data={PromoCode}
            promo_code_id={props.match.params.id}
          />
        )}
      </div>
    </div>
  )
}

export default EditPromoCode
